import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import Header from '../Components/Header';
import Footer from '../Components/Footer';

import { getPortfolio } from '../api/auth/authService';

//import { PreLoginUUID,PostLoginUUID,getToken,saveToken } from '../utils/auth';

function Portfolio() {
  const [portfolioData, setPortfolioData] = useState([]);

  // Fetch portfolio data when the component mounts
  useEffect(() => {

    const fetchPortfolio = async () => {
      try {
        const data = await getPortfolio();
        setPortfolioData(data);
      } catch (error) {
        console.error("Error fetching testimonials:", error.message);
      }
    };
    fetchPortfolio();

  }, []);


  return (
    <div>
      <Header />
      <div className="breadcrumbs overlay">
        <div className="container">
          <div className="bread-inner">
            <div className="row">
              <div className="col-12">
                <h2>Gallery</h2>
                <ul className="bread-list">
                  <li><NavLink to='/'>Home</NavLink></li>
                  <li><i className="icofont-simple-right" /></li>
                  <li className="active">Gallery</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section className="portfolio mt-3 mb-3" >

        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="portfolio-grid">
                {portfolioData.map((item) => (
                  <div className="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 text-center" key={item.id}>
                    <img
                      src={
                        item.imageBytes
                          ? `data:image/jpeg;base64,${item.imageBytes}`
                          : 'https://via.placeholder.com/150'
                      }
                      alt={item.name}
                      className="portfolio-image"
                    />
                    {/* <p className="client-name" style={{ color: '#333', fontWeight: 500, background: '#3183d5ff' }}>{item.name}</p> */}

                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>


      </section>


      <Footer />
    </div>
  );
}

export default Portfolio;
